export default __webpack_public_path__ + "static/media/painting.ee4ec0d5.jpg";